import { createSlice, PayloadAction } from '@reduxjs/toolkit'; //importing create slice
import { RootState } from '../store';
import { sendNotification, getUserCredentialBackup, addToWaitlist, Device, sendNotificationToSpecificUser } from '../actions/notificationActions';


// define initialState

type Notification = {
  title?: string;
  text: string;
  from: string;
  sentTime: string;
  topic?: string | null;
  id: string;
  opened?: boolean;
};

type Waitlist = {
  email: string;
  name: string;
  sentence: string | undefined;
  referral_code?: string | undefined;
  id: string;
  created_at?: Date | string | undefined;
  updated_at?: Date | string | undefined;
}

type State = {
  deviceToken?: string | null;
  deviceTokens: string[] | null;
  notifications: Notification[] | null;
  notOppened: number; 
  loading: boolean;
  error: string | undefined;
  notifTypes: string[];
  waitlist : Waitlist[] | [];
};

const initialState: State = {
  waitlist: [],
  deviceToken: null,
  notifTypes: ['appUpdates',
    'alerts',
    'messages',
    'tips'] 
  ,
  deviceTokens: [],
  notifications: [],
  notOppened: 0,
  loading: false,
  error: undefined,
};

const notificationSlice = createSlice({
  name: 'notification_slice',
  initialState,
  reducers: {
    setNotifications: (state: State, action): void => {
      const currentNotifications = state.notifications ?? [];
      state.notifications = [...currentNotifications, action.payload];
      state.notOppened = state.notOppened + 1;
    },
    setNotification: (state: State, action: PayloadAction<Notification>): void => {
      if (state.notifications) {
       // console.log('set 0notification', action.payload);
        state.notifications = state.notifications?.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
        state.notOppened = state.notOppened - 1;
      }
    },
    deleteNotification: (state: State, action: PayloadAction<Notification>): void => {
      if (state.notifications) {
      //  console.log('delete a notification', action.payload);

        // Filter out the notification to be deleted
        state.notifications = state.notifications.filter((item) => item.id !== action.payload.id);
        /*
        // Logging IDs for debugging
        console.log(
          'state.notifications IDs:',
          state.notifications.map((item) => item.id),
          'new_array IDs:',
          new_array.map((item) => item.id)
        );

        // Update the state with the filtered array
        state.notifications = new_array;
        */
        // Decrement the notOppened counter if the notification wasn't opened
        if (!action.payload.opened) {
          state.notOppened = state.notOppened - 1;
        }
      }
    },
    setToken: (state, action: { type: string; payload: { deviceToken: string } }): void => {
      state.deviceToken = action.payload.deviceToken;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendNotification.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.deviceToken = action.payload;
       // console.log('sendNotification from fullfiled extraReducer ::', action.payload);
      }
    });
    builder.addCase(sendNotification.rejected, (state, action) => {
      state.loading = false;
      if (typeof action.payload === 'string'){
        state.error = action.payload;
      } else if(action.payload instanceof Error){
        state.error = action.payload.message;
      }else{
        state.error = 'Unknown error occurred';
      }
    });
    builder.addCase(sendNotificationToSpecificUser.pending, (state) => {
      state.loading = true;
      state.error = undefined; // Reset error on pending
    });
    builder.addCase(sendNotificationToSpecificUser.fulfilled, (state, action) => {
      state.loading = false;
      state.error = undefined; // Reset error on successful fetch
      if (action.payload) {
        state.deviceToken = action.payload;
       // console.log('sendNotification from fullfiled extraReducer ::', action.payload);
      }
    });
    builder.addCase(sendNotificationToSpecificUser.rejected, (state, action) => {
      state.loading = false;
      if (typeof action.payload === 'string'){
        state.error = action.payload;
      } else if(action.payload instanceof Error){
        state.error = action.payload.message;
      }else{
        state.error = 'Unknown error occurred';
      }
    });
    builder.addCase(getUserCredentialBackup.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserCredentialBackup.fulfilled, (state, action) => {
      state.loading = false;
      state.error = undefined; // Reset error on successful fetch
      if (action.payload && action.payload.devices) {
        console.log('getUserCredentialBackup from fullfiled extraReducer ::', action.payload);
        const tokens = action.payload.devices.map((device: Device) => device.token);
        state.deviceTokens = tokens;
      }
    });
    builder.addCase(getUserCredentialBackup.rejected, (state, action) => {
      state.loading = false;
      if (typeof action.payload === 'string'){
        state.error = action.payload;
      } else if(action.payload instanceof Error){
        state.error = action.payload.message;
      }else{
        state.error = 'Unknown error occurred';
      }
    });
    builder.addCase(addToWaitlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addToWaitlist.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.waitlist = [...state.waitlist, action.payload];
       // console.log('addTowaitlist fullfiled extraReducer ::', action.payload);
      }
    });
    builder.addCase(addToWaitlist.rejected, (state, action) => {
      state.loading = false;
      if (typeof action.payload === 'string'){
        state.error = action.payload;
      } else if(action.payload instanceof Error){
        state.error = action.payload.message;
      }else{
        state.error = 'Unknown error occurred';
      }
    });
  },
});

export const { setToken, setNotifications, setNotification, deleteNotification } =
  notificationSlice.actions;

export const selectState = (state: RootState) => state.notification_slice;

export default notificationSlice.reducer;